var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6a8f4862ebadff5b881dea0cd27479c316d93099"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend-main@flipgive"]={id:"6a8f4862ebadff5b881dea0cd27479c316d93099"};
      